import React, { useState } from "react";
import { Link } from "react-router-dom";

const examples = [
  {
    title: "Prenuptial Agreement Example",
    description:
      "Curious how the AI summarizer works? Check out a real example run on a prenuptial agreement template. You can view the summary, risk analysis, and even download the original document.",
    // This uses the same env var as in App.js for the demo example
    link: `/demo-results/${process.env.REACT_APP_SEE_IT_IN_ACTION_RESULT_ID_1}`,
  },  
  {
    title: "Mutual Cooperation Agreement - Hidden Risks Example",
    description:"This example analyzes a Mutual Cooperation Agreement that appears collaborative on the surface but contains several hidden risks and one-sided obligations. Key issues include perpetual exclusivity, unilateral amendment rights, unlimited audit access, and cost burdens placed solely on one party. Explore how the AI identifies and summarizes these risks, helping you spot red flags in seemingly standard agreements.",
    link: `/demo-results/${process.env.REACT_APP_SEE_IT_IN_ACTION_RESULT_ID_2}`,
  }
  // Add more examples here as needed
  // {
  //   title: "Employment Agreement Example",
  //   description: "See how the tool analyzes a standard employment contract.",
  //   link: "/demo-results/another-id",
  // },
];

export default function SeeItInAction() {
  const [current, setCurrent] = useState(0);
  const total = examples.length;

  const goPrev = () => setCurrent((prev) => (prev === 0 ? total - 1 : prev - 1));
  const goNext = () => setCurrent((prev) => (prev === total - 1 ? 0 : prev + 1));

  const ex = examples[current];

  return (
    <div className="bg-green-50 border border-green-200 rounded-lg shadow-md p-8 text-center max-w-2xl mx-auto my-12">
      <h2 className="text-2xl font-bold text-green-800 mb-4">See It In Action</h2>
      <div className="flex items-center justify-center gap-4">
        {total > 1 && (
          <button
            onClick={goPrev}
            aria-label="Previous example"
            className="p-3 md:p-4 rounded-full bg-white border-2 border-green-600 text-green-700 hover:bg-green-100 hover:border-green-800 focus:outline-none focus:ring-2 focus:ring-green-700 focus:ring-offset-2 transition-colors duration-150 text-2xl font-bold shadow"
            style={{ minWidth: 48, minHeight: 48 }}
          >
            <span aria-hidden="true">&#8592;</span>
          </button>
        )}
        <div className="flex-1 bg-white rounded-lg shadow p-6 text-left min-w-[250px]">
          <h3 className="text-xl font-semibold text-green-700 mb-2">{ex.title}</h3>
          <p className="text-gray-700 mb-4">{ex.description}</p>
          <Link
            to={ex.link}
            className="inline-block px-6 py-3 bg-green-600 text-white rounded-lg text-lg font-semibold hover:bg-green-700 transition-colors shadow"
          >
            View Example Results
          </Link>
        </div>
        {total > 1 && (
          <button
            onClick={goNext}
            aria-label="Next example"
            className="p-3 md:p-4 rounded-full bg-white border-2 border-green-600 text-green-700 hover:bg-green-100 hover:border-green-800 focus:outline-none focus:ring-2 focus:ring-green-700 focus:ring-offset-2 transition-colors duration-150 text-2xl font-bold shadow"
            style={{ minWidth: 48, minHeight: 48 }}
          >
            <span aria-hidden="true">&#8594;</span>
          </button>
        )}
      </div>
      {total > 1 && (
        <div className="mt-4 text-sm text-green-700">Example {current + 1} of {total}</div>
      )}
    </div>
  );
} 